/*
 * Layout barrel file
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

export * from './body/body.component';
export * from './header/header.component';
export * from './footer/footer.component';

